<template>
  <div class="ScholarshipApply">
    <!-- 首頁圖 -->
    <div ref="banner" class="banner">
      <h1>{{ $t("nav.scholarship") }}</h1>
    </div>
    <!-- 申請時序 -->
    <div class="content-container">
      <!-- 標題 -->
      <div ref="first_tit" class="title">
        <span>{{ $t("scholarship.time_tit") }}</span>
      </div>
      <!-- <span>{{ $t("scholarship.test_span") }}</span> -->
      <!-- <p class="desc">{{ $t("scholarship.plan_tit") }}</p> -->
      <!--<div class="time-line">
        <div class="line-item" v-for="(item, index) in applyData.time_line" :key="index">
          <div class="time" :class="selectTimeItem === index ? 'active-time' : ''" @click="changeTimeLine(index)">
            <span class="time-tit">{{ item.title }}</span>
            <div class="circle">
              <div class="line" :class="selectTimeItem === index ? 'active-line' : ''" v-show="index < applyData.time_line.length - 1" />
            </div>
          </div>
          <div class="time-story" v-show="selectTimeItem === index">
            <! <p class="con-tit">{{ item.title }}</p> --
            <p class="con">{{ item.content }}</p>
          </div>
        </div>
      </div>-->
      <div class='timeline-outer-container'>
        <div class='timeline-container'>
          <div class='title-container'>
            <div class='content'>
              {{ $t("scholarship.time_tit") }}
              <div class='baseline'></div>
            </div>
          </div>
          <div :class='["content-container", !item.green ? "content-container-blue" : ""]' v-for='(item, i) in timeline' :key='i'>
            <div class='line'></div>
            <div :class='["pointer", item.left ? "left-pointer" : "right-pointer"]'></div>
            <div :class='["stage-container", !item.left ? "stage-container-right" : ""]'>
              <div class="count">
                {{ i+1 }}
              </div>
              <div class='stage-title'>
                {{ $t(item.title) }}
              </div>
              <div class='stage-text'>
                <span>{{$t(item.text)}}</span>
                <div class='baseline'></div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
      <div class='submit-deadline'>
        <div class='text'>
          {{ $t('home.submit_deadline_text') }}
        </div>
        <div class='container'>
          <div class="item"></div>
          <div class="item">{{ $t('home.submit_deadline0') }}</div>
          <div class="item">{{ $t('home.release_month0') }}</div>  
          <div class="item">1</div>
          <div class="item">{{ $t('home.submit_deadline1') }}</div>
          <div class="item">{{ $t('home.release_month1') }}</div>  
          <div class="item">2</div>
          <div class="item">{{ $t('home.submit_deadline2') }}</div>
          <div class="item">{{ $t('home.release_month2') }}</div> 
          <div class="item">3</div>
          <div class="item">{{ $t('home.submit_deadline3') }}</div>
          <div class="item">{{ $t('home.release_month3') }}</div> 
        </div>
      </div>
      <!-- 其他注意事项 -->
      <div class="other-tips-container">
        <p v-for="item in applyData.other_tips" :key="item" v-html="item"></p>
      </div>
      <CoButton :href="$i18n.locale == 'zh_hk' ? 'https://form.jotform.me/200901208739048' : 'https://form.jotform.me/201422358161446'" class="apply-btn">
        {{ applyData.other_btn }}
      </CoButton>
      <!-- 計劃概括時間線 -->
      <!--<div class="time-line-detail">
        <div :class="['detail-item', { 'detail-item-close': !item.expand }]" v-for="(item, index) in applyData.timeLines_Detail" :key="index" ref="detailItem" v-show="index===0">
          <span class="title">{{ item.phase }}</span>
          <div @click="toggleHeight(index)" :class="['close-btn', { 'close-btn-close': !item.expand }]">
            <span></span>
            <span></span>
          </div>
          <ul class="time-line-list">
            <li class="time-year" v-for="(item1, index) in item.info" :key="index">
              <span>{{ item1.year }}</span>
              <div class="border"></div>
              <ul>
                <li v-for="(item2, index) in item1.info" :key="index">
                  <div class="time-month">{{ item2.month }}</div>
                  <div class="time-month-info">
                    {{ item2.content }}
                    <p v-show="item2.desc">{{ item2.desc }}</p>
                    <span v-show="item2.tips" class="tips">
                      {{ item2.tips }}
                    </span>
                  </div>
                  <div v-show="index !== item1.info.length - 1" class="triangle">
                    <img src="../assets/img/apply/4.png" />
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>-->
    </div>
    <CommonSlogan />
  </div>
</template>

<script>
import CoButton from "../components/co-button/co-button.vue";
import CommonSlogan from "../components/CommonSlogan.vue";
export default {
  name: "ScholarshipApply",
  data () {
    return {
      timeline: [
        {
          text: this.$t('home.timeline[0]'),
          title: this.$t('home.timeline_title[0]'),
          left: true,
          green: false
        },
        {
          text: this.$t('home.timeline[1]'),
          title: this.$t('home.timeline_title[1]'),
          left: false,
          green: false
        },
        {
          text: this.$t('home.timeline[2]'),
          title: this.$t('home.timeline_title[2]'),
          left: true,
          green: false
        },
        {
          text: this.$t('home.timeline[3]'),
          title: this.$t('home.timeline_title[3]'),
          left: false,
          green: false
        },
        {
          text: this.$t('home.timeline[4]'),
          title: this.$t('home.timeline_title[4]'),
          left: true,
          green: false
        },
        {
          text: this.$t('home.timeline[5]'),
          title: this.$t('home.timeline_title[5]'),
          left: false,
          green: false
        },
        {
          text: this.$t('home.timeline[6]'),
          title: this.$t('home.timeline_title[6]'),
          left: true,
          green: true
        },
        {
          text: this.$t('home.timeline[7]'),
          title: this.$t('home.timeline_title[7]'),
          left: false,
          green: true
        },
        {
          text: this.$t('home.timeline[8]'),
          title: this.$t('home.timeline_title[8]'),
          left: true,
          green: true
        },
      ],
      selectTimeItem: 0,
    };
  },
  components: { CommonSlogan, CoButton },
  methods: {
    changeTimeLine (index) {
      this.selectTimeItem = index;
    },
    // 切换时间线详情显示/隐藏
    toggleHeight (index) {
      this.$nextTick(function () {
        // console.log(this.applyData.timeLines_Detail[index].expand);
        this.applyData.timeLines_Detail[index].expand = !this.applyData.timeLines_Detail[index]
          .expand;
      });
      if (this.$refs.detailItem[index].offsetHeight >= 500) {
        this.$refs.detailItem[index].style.height = "8vw";
      } else {
        this.$refs.detailItem[index].style.height = "auto";
      }
    }
  },
  computed: {
    applyData: function () {
      return this.$t("scholarship");
    },
  },
};
</script>

<style scoped lang="scss">
.submit-deadline {
  margin-top: 30px;
  box-sizing: border-box;
  padding: 30px 0;
  width: 100%;
  height: 410px !important;
  background-color: white;
  border-radius: 15px;
  border: 1px solid #dad8d8;
  .text {
    text-align: center;
    padding: 0 30px;
  }
  .container {
    display: grid;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
    width: 70%;
    grid-template-columns: 2fr 5fr 5fr;
    .item {
      border: 1px solid rgba(0, 0, 0, 0.8);
      padding: 20px;
      font-size: 17px !important;
      text-align: center;
    }
  }
}
.timeline-outer-container {
  cursor: pointer;
  height: 700px;
  padding: 30px 0;
  overflow-y: auto;
  background-color: white;
  border-radius: 15px;
  border: 1px solid #dad8d8;
}
.timeline-container {
  zoom: 0.58;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 1195px;
  .title-container {
    border-radius: 8px;
    background-color: #f8d95d;
    width: 250px;
    height: 70px;
    border: none;
    padding: 8px;
    box-sizing: border-box;
    .content {
      position: relative;
      font-size: 20px;
      box-sizing: border-box;
      color: white;
      border: 1px solid #f7e8ab;
      height: 100%;
      text-align: center;
      padding-top: 8px;
      .baseline {
        position: absolute;
        bottom: 8px;
        width: 80%;
        height: 1px;
        left: 10%;
        background-color: #f7e8ab;
      }
    }
  }
  .content-container {
    position: relative;
    width: 70%;
    height: 125px;
    .line {
      position: absolute;
      z-index: 10;
      width: 3px;
      height: 100%;
      left: 50%;
      transform: translateX(-1.5px);
      background-color: #85c358;
    }
    .line::before {
      content: '';
      position: absolute;
      width: 25px;
      height: 25px;
      border-radius: 50%;
      box-sizing: border-box;
      top: 50%;
      background-color: white;
      transform: translate(-11px, -12.5px);
      border: 3px solid #85c358;
      z-index: 1;
    }
    .pointer {
      position: absolute;
      width: 15%;
      height: 1px;
      top: 50%;
      background-color: #85c358;
    }
    .left-pointer {
      right: 50%;
    }
    .right-pointer {
      left: calc(50% + 12.5px);
    }
    .pointer::before {
      content: '';
      position: absolute;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      top: 50%;
      background-color: #85c358;
      transform: translate(0, -2.5px);
      z-index: 1;
    }
    .right-pointer::before {
      right: 0;
    }
    .stage-container {
      position: relative;
      height: 100%;
      width: 50%;
      .count {
        position: absolute;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        text-align: center;
        line-height: 30px;
        vertical-align: middle;
        color: white;
        background-color: #85c358;
        z-index: 5;
      }
      .stage-title {
        position: absolute;
        left: 50px;
        padding: 5px;
        background-color: #85c358;
        z-index: 5;
        color: white;
        font-size: 15px;
      }
      .stage-text {
        position: absolute;
        display: table;
        width: 70%;
        height: 80%;
        border: 1px solid #85c358;
        border-radius: 5px;
        box-sizing: border-box;
        top: 15px;
        left: 15px;
        padding: 0 15px;
        color: #85c358;
        text-align: center;
        span {
          display: table-cell;
          vertical-align: middle;
        }
        .baseline {
          position: absolute;
          bottom: 10px;
          width: 80%;
          height: 1px;
          left: 10%;
          background-color: #85c358;
        }
      }
    }
    .stage-container-right {
      margin-left: 50%;
      .count {
        left: calc(30% - 15px);
      }
      .stage-title {
        left: calc(30% + 35px);
      }
      .stage-text {
        left: 30%;
      }
    }
  }
  .content-container-blue {
    .line {
      background-color: #2191d0;
    }
    .line::before {
      border: 3px solid #2191d0;
    }
    .pointer {
      background-color: #2191d0;
    }
    .pointer::before {
      background-color: #2191d0;
    }
    .stage-container {
      .count {
        background-color: #2191d0;
      }
      .stage-title {
        background-color: #2191d0;
      }
      .stage-text {
        border: 1px solid #2191d0;
        color: #2191d0;
        .baseline {
          background-color: #2191d0;
        }
      }
    }
  }
}
.timeline {
  box-sizing: border-box;
  padding: 30px 70px;
  width: 100%;
  height: 105px;
  margin-bottom: 10px;
  background-color: white;
  border-radius: 15px;
  border: 1px solid #dad8d8;
  display: flex;
  flex-direction: column;
  .legend {
    display: flex;
    justify-content: space-around;
    height: 100px;
    margin: 0 auto;
    .phase1 {
      margin-right: 70px;
    }
    .phase2 {
      margin-left: 70px;
    }
    .phase1, .phase2 {
      display: flex;
      .text {
        margin-left: 20px;
        margin-top: 8px;
      }
    }
    .icon1 {
      width: 25px;
      height: 25px;
      background-color: white;
      border-radius: 50%;
      border: 7px solid #2191d0;
    }
    .icon2 {
      width: 25px;
      height: 25px;
      background-color: white;
      border-radius: 50%;
      border: 7px solid #85c358;
    }
  }
}
.ScholarshipApply {
  .banner {
    background-image: url("../assets/img/apply/scholarship.jpg");
  }
  .content-container {
    background: rgba($color: white, $alpha: 0.3);
    .btn-nav {
      display: flex;
      justify-content: space-around;
      margin: 42px 0;
    }
    .time-line {
      margin: 0 auto;
      border-radius: 15px;
      border: 1px solid #dad8d8;
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 1.8vw;
      padding: 20px 0 100px;
      .line-item {
        display: flex;
        justify-content: center;
        position: relative;
        width: 15%;
        .time {
          display: flex;
          flex-direction: column;
          align-items: center;
          .time-tit {
            text-align: center;
            height: 7vw;
            display: flex;
            flex-direction: column-reverse;    
            width: 110%;
          }
          .circle {
            width: 1vw;
            height: 1vw;
            border-radius: 50%;
            border: 0.3vw solid #85c358;
            background: #fff;
            margin: 1vw 0;
            position: relative;
            z-index: 1;
            cursor: pointer;
            &:hover {
              width: 1.5vw;
              height: 1.5vw;
              // border: 0.5vw solid #2191d0;
              .line {
                transform: translateY(0.6vw) translateX(2vw);
              }
            }
            .line {
              width: 150px;
              height: 0.5vw;
              background: #dfe0e2;
              transform: translateY(0.4vw) translateX(1.4vw);
            }
            .active-line {
              background: #85c358;
            }
          }
        }
        .active-time {
          color: #85c358;
          .circle {
            border: 0.5vw solid #85c358 !important;
            width: 1.5vw;
            height: 1.5vw;
            .line {
              transform: translateY(0.6vw) translateX(1.8vw);
            }
          }
        }
        .time-story {
          width: 12vw;
          position: absolute;
          background: #85c358;
          color: #fff;
          top: 12vw;
          left: 5.5vw;
          box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
          border-radius: 3px;
          &::before {
            content: "";
            width: 0px;
            height: 0px;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-bottom: 10px solid #85c358;
            position: absolute;
            top: -10px;
            left: 10px;
          }
          .con {
            font-size: 12px;
            padding: 15px;
            color: #fff;
          }
        }
        // &:nth-child(4) .circle,
        // &:nth-child(5) .circle,
        // &:nth-child(6) .circle {
        //   border-color: #2191d0 !important;
        //   .active-line {
        //     background: #2191d0;
        //   }
        // }
        // &:nth-child(4) .active-time,
        // &:nth-child(5) .active-time,
        // &:nth-child(6) .active-time {
        //   color: #2191d0 !important;
        // }
        // &:nth-child(7) .circle {
        //   border-color: #df8244 !important;
        // }
        // &:nth-child(7) .active-time {
        //   color: #df8244 !important;
        // }
      }
    }
    .other-tips-container {
      margin-top: 80px;
    }
    .time-line-detail {
      margin: 10vw 0 3vw;
      display: flex;
      justify-content: space-between;
      .detail-item {
        width: 33vw;
        box-shadow: 0px 3px 5px 5px #ccc;
        border-radius: 1.5vw;
        background: rgba($color: white, $alpha: 0.3);
        position: relative;
        text-align: center;
        overflow: hidden;
        transition: all ease-in-out 0.3s;
        padding: 2vw 0;
        margin: 0 auto;
        // &:last-child {
        //   margin-left: 2.5vw;
        // }
        .title {
          margin: 0;
          display: inline-block;
          font-size: 2vw;
          height: 5vw;
          color: black;
        }
        .close-btn {
          width: 4vw;
          height: 4vw;
          background: #85c357;
          border-radius: 0 1.8vw;
          position: absolute;
          right: -1px;
          top: -1px;
          cursor: pointer;
          & > span {
            display: inline-block;
            width: 2vw;
            height: 0.3vw;
            border-radius: 0.3vw;
            background: white;
            position: absolute;
            right: 1vw;
            top: 2vw;
            &:last-child {
              transform: rotate(90deg);
            }
          }
        }
        .close-btn-close {
          background: none;
          & > span {
            background: #85c357;
          }
          & > span:last-child {
            display: none;
          }
        }
        .time-line-list {
          color: #229fd8;
          text-align: left;
          text-indent: 2vw;
          .time-year {
            font-size: 28px;
            .border {
              height: 0.3vw;
              background: #229fd8;
              margin: 1.5vw;
            }
            & > ul {
              padding-left: 1vw;
              text-indent: 0;
              & > li {
                & > div {
                  margin-bottom: 0.6vw;
                  padding: 0 1vw;
                }
                .time-month {
                  font-size: 24px;
                  .blod-month {
                    font-weight: 600;
                  }
                }
                .time-month-info {
                  font-size: 16px;
                  color: black;
                  & > p {
                    width: 24.6vw;
                  }
                  .tips {
                    line-height: 2vw;
                    font-size: 12px;
                    display: block;
                    padding-top: 2vw;
                  }
                }
                .triangle {
                  font-size: 2.2vw;
                  margin: 0;
                }
              }
            }
          }
          & > li + li {
            margin-top: 40px;
          }
        }
      }
    }
    .apply-btn {
      display: block;
      width: 15%;
      margin: 20px auto;
    }
  }
  .submit-container-bg {
    width: 100%;
    background: #f3f3f3;
    padding: 4vw 3vw;
    box-sizing: border-box;
    margin-top: 5vw;
    max-width: unset;
    .submit-container {
      max-width: 1200px;
      margin: 0 auto;

      .title {
        margin: 0;
      }
      .date {
        line-height: 8.5vw;
        font-size: 23px;
        font-weight: 600;
      }
      .submit-item-container {
        display: flex;
        justify-content: space-around;
        align-items: center;
        .submit-item {
          width: 50%;
          background: white;
          border-radius: 1vw;
          display: inline-block;
          position: relative;
          overflow: hidden;
          text-align: center;
          max-width: 450px;
          padding: 0 1vw 1vw;
          &::after {
            content: "";
            width: 5vw;
            height: 6.5vw;
            background: #229fd8;
            position: absolute;
            left: -3.2vw;
            top: -3.2vw;
            transform: rotate(45deg);
          }
          &:last-child {
            margin-left: 2.4vw;
          }
          .title {
            font-size: 23px;
            line-height: 70px;
            color: #229fd8;
          }
          .border {
            width: 35.2vw;
            height: 0.2vw;
            background: #229fd8;
            margin: 0 auto 2.2vw;
          }
          .con {
            margin: 0 auto;
            padding: 0 2vw 2vw;
          }
          .tag {
            width: 85%;
            background: #229fd8;
            margin: 0 auto;
            padding: 0 3.6vw;
            box-sizing: border-box;
            font-size: 1.4vw;
            line-height: 3vw;
            color: white;
            cursor: pointer;
          }

          &:last-child::after {
            background: #85c357;
          }
          &:last-child {
            .title {
              color: #85c357;
            }
            .border,
            .tag {
              background: #85c357;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .timeline-outer-container {
    height: 370px;
    overflow-y: hidden;
  }
  .timeline-container {
    zoom: 0.3;
    .content-container {
      width: 100%;
      .line {
        height: 120%;
      }
      .stage-container {
        .stage-title {
          font-size: 12px;
        }
        .stage-text {
          font-size: 13px;
        }
      }
    }
  }
  .timeline {
    height: 150px;
    font-size: 12px;
    .legend {
      display: flex;
      flex-direction: column;
      .phase1 {
        margin-right: 0;
      }
      .phase2 {
        margin-left: 0;
        margin-top: 10px;
      }
    }
  }
  .submit-deadline {
    height: 470px !important;
    .container {
      .item {
        font-size: 12px !important;
      }
    }
  }
  .ScholarshipApply {
    .banner {
      height: 40vw;
      display: flex;
      flex-direction: column;
      align-items: center;
      background-image: url("../assets/img/apply/scholarship.jpg");
      background-size: cover;
      background-repeat: no-repeat;
      color: white;
      h1 {
        line-height: 14vw;
        font-size: 7vw;
      }
    }
    .content-container {
      width: 90%;
      margin: 0 auto 4.4vw;
      font-size: 1.7vw;
      background: rgba($color: white, $alpha: 0.3);
      .title {
        color: #85c456;
        margin: 3.4vw auto 2.8vw;
        font-size: 5vw;
        & > span {
          border-bottom: solid 0.5vw #22a0d6;
          padding-bottom: 1vw;
        }
      }
      .desc {
        font-size: 3vw;
      }
      .time-line {
        padding: 50px 0 180px;
        .line-item {
          display: flex;
          align-items: center;
          .time {
            display: flex;
            flex-direction: column;
            align-items: center;
            letter-spacing: 0px;
            width: 10vw;
            font-size: 10px;
            .time-tit {
              height: 60px;
            }
            .circle {
              width: 1.8vw;
              height: 1.8vw;
              border-radius: 50%;
              background: #fff;
              margin: 10px 0;
              position: relative;
              z-index: 1;
              cursor: pointer;
              &:hover {
                width: 2vw;
                height: 2vw;
                // border: 0.5vw solid #2191d0;
                .line {
                  transform: translateY(1vw) translateX(2.7vw);
                }
              }
              .line {
                width: 12vw;
                height: 0.5vw;
                background: #dfe0e2;
                transform: translateY(1vw) translateX(2.7vw);
              }
              .active-line {
                background: #85c358;
              }
            }
          }
          .active-time {
            color: #85c358;
            .circle {
              width: 2vw;
              height: 2vw;
              .line {
                transform: translateY(1vw) translateX(2.7vw);
              }
            }
          }
          .time-story {
            width: 104px;
            top: 27vw;
            left: 0vw;
            &::before {
              left:15px
            }
            .con {
              width: 20vw;
            }
            .con-tit {
              border-bottom: 1px solid #fff;
              padding-bottom: 5px;
              line-height: 5vw;
              text-align: center;
              font-size: 3.5vw;
            }
          }
          // &:nth-child(4) .circle,
          // &:nth-child(5) .circle,
          // &:nth-child(6) .circle {
          //   .active-line {
          //     background: #2191d0;
          //   }
          // }
          // &:nth-child(7) .active-time {
          //   color: #df8244 !important;
          // }
        }
      }
      .time-line-detail {
        display: block;
        .detail-item {
          min-height: 14vw;
          height: 20vw;
          width: 100%;
          box-shadow: 0px 3px 5px 5px #ccc;
          border-radius: 1.5vw;
          background: rgba($color: white, $alpha: 0.3);
          position: relative;
          text-align: center;
          overflow: hidden;
          transition: all ease-in-out 1s;
          &:last-child {
            margin: 4vw 0 0 0;
          }
          .title {
            margin: 0;
            display: inline-block;
            font-size: 5vw;
            line-height: 10vw;
            color: black;
          }
          .close-btn {
            width: 10vw;
            height: 10vw;
            background: #85c357;
            border-radius: 0 1.8vw;
            position: absolute;
            right: -1px;
            top: -1px;
            cursor: pointer;
            & > span {
              display: inline-block;
              width: 5.5vw;
              height: 0.5vw;
              border-radius: 0.3vw;
              background: white;
              position: absolute;
              right: 2vw;
              top: 4.4vw;
              &:last-child {
                transform: rotate(90deg);
              }
            }
          }
          .close-btn-close {
            background: none;
            & > span {
              background: #85c357;
            }
            & > span:last-child {
              display: none;
            }
          }
          .time-line-list {
            color: #229fd8;
            text-align: left;
            text-indent: 2.9vw;
            .time-year {
              font-size: 5vw;
              .border {
                height: 0.3vw;
                background: #229fd8;
                margin: 2.1vw 0 3vw;
              }
              & > ul {
                padding: 0 3vw;
                text-indent: 0;
                & > li {
                  & > div {
                    margin-bottom: 3vw;
                  }
                  .time-month {
                    font-size: 5vw;
                    .blod-month {
                      font-weight: 600;
                    }
                  }
                  .time-month-info {
                    font-size: 3vw;
                    color: black;
                    & > p {
                      width: 100%;
                    }
                    .tips {
                      line-height: 10vw;
                    }
                  }
                  .triangle > img {
                    width: 5vw;
                  }
                }
              }
            }
          }
        }
        .detail-item-close {
          height: 235vw;
        }
      }
      .more-btn {
        width: 30%;
      }
    }
  }
}
</style>
